<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="练习记录" goBack="true"></head-top>
		<div class="con">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-list :offset="40" v-model="loading" :finished="finished" :immediate-check="false"
					:finished-text="finishedText" @load="onLoad" v-if="list.length>0">
					<div v-for="(item,index) in list" :key="item.id" class='list_item'>
						<div class="practice_name ellipsis_1">{{item.practiceName}}</div>
						<div class="flex_c" style="width: 100%;">
							<div class="btns_c" @click="seePracticeList(item.id)">查看练习</div>
							<div class="btns_c" @click="toRedoPage(item.id,item.practiceId)">重新练习</div>
							<div class="btns_c" @click="delete_my_question(item.id,index)">删除练习</div>
						</div>
					</div>

				</van-list>
				<div v-else class="color_e font_size_c paddinga">
					<img :src='resourceDomain+"static/icon/no_order.png"' class="noorder">
					暂无数据，逛逛别的分类吧~
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	export default {
		name: 'PracticeChapterHistory',
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				page: 0,
				pages: undefined,
				list: [],
				loading: false,
				finished: false,
				finishedText: "",
				isLoading: false
			}
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {},
		activated() {
			this.updatePage()
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
			updatePage() {
				this.list = [];
				this.page = 0;
				this.loading = true
				this.finished = false
				this.finishedText=''
				this.getChapterHistoryRecord()
			},

			// 获取练习记录
			getChapterHistoryRecord() {
				this.$toast.loading({
					overlay: true,
					message: "加载中...",
					duration: 0,
				});
				let list = this.list;
				let page = this.page + 1;
				api.get('/mp/practice/question/chapterHistoryRecord', {
					current: page,
					size: 10
				}).then(res => {
					this.$toast.clear();
					if (res.code == 20000) {
						if (res.data.list.length > 0) {

							for (var i = 0; i < res.data.list.length; i++) {
								list.push(res.data.list[i])
							}

							this.list = list;
							this.page = page;
							this.pages = res.data.pages;
							// 加载状态结束
							this.isLoading = false
							this.loading = false
							// 设置是否可以继续上拉加载
							if (this.page == this.pages) {
								this.finished = true
							} else {
								this.finished = false
							}
							this.finishedText = "没有更多了~"

						} else {
							this.finished = true
							this.finishedText = ""
							this.list = []
						}
					} else {
						this.$toast(res.message);
					}

				})
			},

			/**下拉刷新 */
			onRefresh() {
				console.log("----")
				this.page = 0;
				this.list = [];
				this.getChapterHistoryRecord()
				this.isLoading = false;
			},
			/**上拉加载 */
			onLoad() {
				console.log("+++")
				if (this.page == this.pages) {
					this.$toast('没有更多咯~')
				} else {
					this.$toast.loading({
						overlay: true,
						message: "加载中...",
						duration: 0,
					});
					this.getChapterHistoryRecord()
				}
			},

			/**查看练习 */
			seePracticeList(id) {
				this.$router.push({
					'path': '/practice_chapter_history_detail',
					query: {
						id: id
					}
				})
			},

			/**跳转重新练习页面 */
			toRedoPage(id, practiceId) {
				this.$router.push({
					'path': '/practice_chapter_history_redo',
					query: {
						id: id,
						chapterId: practiceId
					}
				})

			},

			/** 删除练习 */
			delete_my_question(id, index) {
				this.$toast.loading({
					overlay: true,
					message: "加载中...",
					duration: 0,
				});
				api.post(`/mp/practice/question/chapterHistoryRecordDelete/${id}`).then((res) => {
					console.log(res)
					this.$toast.clear();
					if(res.code == 20000){
						this.$toast.success("删除成功");
						var list = this.list;
						list.splice(index, 1);
						this.list = list
					}
				})
			},
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.con {
		padding-top: 48px
	}

	.list_item {
		background-color: #FFF;
		margin: 20px auto;
		padding: 15px;
		width: 315px;
		font-size: 16px;
	}

	.practice_name {
		padding-bottom: 15px;
	}

	.btns_c {
		padding: 5px 15px;
		color: #FFF;
		background-color: #38f;
		font-size: 15px;
		border-radius: 8px;
	}

	.paddinga {
		text-align: center;
		padding: 15px 0;
	}

	.noorder {
		width: 345px;
		height: 172.5px;
		margin: 15vh auto 25px;
		display: block;
	}
</style>